import { useContext, useState } from "react";
import { InvoiceData } from "../funcs/invoiceData";
import useNewId from "../funcs/hooks/useNewId";
import { context } from "../context/context";
import { switchh } from "../context/switch";

export default function AddWeight (props) {
    const [weight, setWeight] = useState('');
    const { setCart } = useContext(context);
    const { setEnableAddWeightManully, intialAddWeightManually } = useContext(switchh);
    const newId = useNewId();
    
    const reset = () => {
        setEnableAddWeightManully(intialAddWeightManually);
    }

    const data = props.data;
    
    const putInvoice = (e) => {
        e.preventDefault();
        const collect = InvoiceData(
            newId,
            data.id,
            data.barcode,
            data.title,
            data.price,
            weight,
            data.type,
            data.discount,
            data.flagInv
        );

        setCart((prev) => [...prev, collect]);
        reset();
    }
    return (
        <div className="access-container container-box fixed flex flex-center-center">
            <div className="box center">
                <button className="close" onClick={()=>reset()}>x</button>
                <div className="content">
                    <h2>ادخل وزن المنتج</h2>
                    <div className="details">
                        <p>اسم المنتج</p>
                    </div>
                    <form onSubmit={putInvoice}>
                        <input autoFocus type="text" value={weight} onChange={(e) => {
                            const data = e.target.value;
                            if(/^[0-9.]*$/.test(data)) {
                                setWeight(e.target.value);
                            }
                        }} placeholder="ادخل الوزن المطلوب (بالكيلو)" />
                        <div className="center">
                            <button className="btn">تأكيد الوزن</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}